export const SUPPLIER_PRIMARY_BUTTON_CLASS =
  "bg-primary text-white px-4 py-2 rounded-lg border border-primary shadow-md hover:bg-primary/90 transition-all flex items-center gap-2 text-sm font-medium";

export const SUPPLIER_FILTER_LABEL_CLASS = "mb-1.5 block text-xs font-medium text-gray-600";

export const SUPPLIER_FILTER_SELECT_CLASS =
  "w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary/20";

export const SUPPLIER_FILTER_INPUT_CLASS =
  "w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary/20";

export function SupplierAddButton({
  onClick,
  children,
  className = "",
  type = "button",
  icon = "fi fi-rr-plus",
  ...props
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`${SUPPLIER_PRIMARY_BUTTON_CLASS} ${className}`}
      {...props}
    >
      {icon ? <i className={icon} /> : null}
      {children}
    </button>
  );
}

export function SupplierFilterToolbar({ children, onReset, showReset = false }) {
  return (
    <div className="flex flex-col gap-3 w-full">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-3 items-end">
        {children}
      </div>
      {showReset ? (
        <div className="flex justify-end">
          <button
            type="button"
            onClick={onReset}
            className="text-sm font-semibold text-gray-700 border border-gray-200 px-3 py-2 rounded-lg hover:bg-gray-50"
          >
            Reset filters
          </button>
        </div>
      ) : null}
    </div>
  );
}

export function SupplierFilterField({ label, children, className = "md:col-span-3" }) {
  return (
    <div className={className}>
      {label ? <label className={SUPPLIER_FILTER_LABEL_CLASS}>{label}</label> : null}
      {children}
    </div>
  );
}

export function SupplierPageLoading({ message = "Loading..." }) {
  return (
    <div className="flex items-center justify-center h-64">
      <div className="flex items-center gap-3">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
        <span className="text-primary font-medium">{message}</span>
      </div>
    </div>
  );
}
